import React from 'react';
import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import { Circle } from 'components/Shapes';
import {
  CIRCLES_HEIGHT,
  CIRCLES_WIDTH,
  CIRCLE_SIZES
} from '../../pulse.common';

const CirclesWrapper = styled(Flex)`
  position: relative;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: ${CIRCLES_WIDTH}rem;
  max-width: ${CIRCLES_WIDTH}rem;
  height: ${CIRCLES_HEIGHT}rem;
`;

const CircleWrapper = styled(Flex)`
  justify-content: center;
  align-items: center;
`;

const getCirclesPosition = (circle1, circle2) => {
  switch (circle1) {
    case CIRCLE_SIZES.S:
      switch (circle2) {
        case CIRCLE_SIZES.S:
          return '0.75rem';
        case CIRCLE_SIZES.M:
          return '0.5rem';
        case CIRCLE_SIZES.L:
          return '0.25rem';
        default:
          return 0;
      }
    case CIRCLE_SIZES.M:
      switch (circle2) {
        case CIRCLE_SIZES.S:
          return '0.5rem';
        case CIRCLE_SIZES.M:
          return '0.25rem';
        case CIRCLE_SIZES.L:
        default:
          return 0;
      }
    case CIRCLE_SIZES.L:
      switch (circle2) {
        case CIRCLE_SIZES.S:
          return '0.25rem';
        case CIRCLE_SIZES.M:
        case CIRCLE_SIZES.L:
        default:
          return 0;
      }
    default:
      return 0;
  }
};

export const TwoCircles = ({ circles }) => {
  if (!circles || circles.length === 0) {
    return <CirclesWrapper />;
  }
  const hasOneCircle = circles.length === 1;
  const position = hasOneCircle
    ? null
    : getCirclesPosition(circles[0].size, circles[1].size);
  return (
    <CirclesWrapper>
      {circles.map(({ size, color, opacity }, idx) => {
        const style = hasOneCircle
          ? {}
          : {
              position: 'absolute',
              ...(idx === 0 ? { left: position } : { right: position })
            };
        return (
          <CircleWrapper key={idx}>
            <Circle size={size} color={color} opacity={opacity} style={style} />
          </CircleWrapper>
        );
      })}
    </CirclesWrapper>
  );
};
